import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

export const INTEGRATIONS_ROUTE = '/configuracoes/integracoes';

/// Volta para de onde veio; aberto por link, sem tela anterior, vai à lista de integrações.
export const IntegrationBackButton = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    const goBack = () => {
        if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
        else navigate(INTEGRATIONS_ROUTE);
    };

    return (
        <Box
            role="button"
            tabIndex={0}
            onClick={goBack}
            onKeyDown={(e) => e.key === 'Enter' && goBack()}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                height: 32,
                px: 1.5,
                mb: 1.75,
                color: cc.textPrimary,
                fontSize: 13,
                fontWeight: 700,
                bgcolor: cc.countBg,
                border: `1px solid ${cc.borderStrong}`,
                borderRadius: '9px',
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { borderColor: cc.borderHover },
            }}
        >
            <ArrowBackIcon sx={{ fontSize: 17 }} />
            {t('telaLead.voltar')}
        </Box>
    );
};
